<div class="form-row" style="margin-top: -10px; margin-bottom: 10px;">
    <div class="form-group form-group-dialog-title">
        <span style="color: #2F6ABC;font-weight: bold;font-style: italic;font-size: 30px;font-family: revert;">
            Info
        </span>
    </div>
</div>

<mat-divider></mat-divider>

<mat-dialog-content class="form-row mat-typography conteudo-dialog-propaganda">
    <div class="form-group" style="font-size: 16px;">
        <span style="font-weight: bold;font-family: revert; font-size: 18px;">
            Planos IASSEPE e HAPVIDA (Consulta Geral)
        </span>
        <br />
        O agendamento deve ser realizado diretamente pelos canais oficiais do seu convênio. <br />
        Entre em contato com o IASSEPE ou o HAPVIDA para efetuar sua marcação.
        <br /><br />
        <span style="font-weight: bold;font-family: revert; font-size: 18px;">
            Consulta Oftalmológica (Subespecialidades HAPVIDA)
        </span>
        <br />
        <span style="font-size: 18px;font-style: italic">
            Atenção:
        </span>
        <span style="font-style: italic">
            Para realizar sua marcação, <br /><strong>é obrigatório apresentar o encaminhamento</strong> emitido por um dos nossos profissionais médicos.
        <br />
            A apresentação deste encaminhamento também <strong>é obrigatória no dia da consulta.</strong><br />
            Sem o encaminhamento, <strong>o atendimento não poderá ser realizado.</strong>
        </span>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-stroked-button color="primary" [mat-dialog-close]="true">Fechar</button>
</mat-dialog-actions>